import { Login } from "./Login/Login.js";
import "react";
import { jsx } from "react/jsx-runtime";
// src/modules/AuthWrapper2/components/AuthGate.tsx
function AuthGate() {
	return /* @__PURE__ */ jsx("div", {
		className: "flex h-dvh w-full flex-col items-center justify-center overflow-auto",
		children: /* @__PURE__ */ jsx(Login, {})
	});
}
export { AuthGate };

//# sourceMappingURL=AuthGate.js.map